// extracted by mini-css-extract-plugin
export var active = "q_bd";
export var activeTargetContainer = "q_bJ";
export var container = "q_b";
export var content = "q_bP";
export var contentButton = "q_bQ";
export var feature = "q_bM";
export var featureContainer = "q_bL";
export var featureText = "q_bN";
export var features = "q_bK";
export var footer = "q_bR";
export var footerText = "q_bS";
export var icon = "q_bz";
export var outerFeaturesContainer = "q_bH";
export var section = "q_j";
export var text = "q_bw";
export var title = "q_g";
export var topButton = "q_bG";
export var waveOne = "q_q";
export var waveThree = "q_bF";
export var waveTwo = "q_n";
export var waves = "q_bD";